<div class="public-top-bar sticky-top">
  <div class="container">
    <header class="d-flex align-items-center top-header">
      <a href="/" class="d-flex align-items-center text-decoration-none top-header-logo">
        <img src="images/logo2.png" alt="มกอช." class="logo">
      </a>

      <ul class="nav justify-content-center top-nav-menu" [class.top-nav-menu--open]="menuOpen">
        <li>
          <a [href]="homeUrl" class="nav-link px-2 link-white" target="_blank" rel="noopener noreferrer">
            หน้าแรก
          </a>
        </li>
        @if (isAuthenticated()) {
          <li>
            <a routerLink="/public/search/standard" routerLinkActive="active" class="nav-link px-2 link-white">
              ข้อมูลมาตรฐาน
            </a>
          </li>
          <li>
            <a routerLink="/public/search/importq" routerLinkActive="active" class="nav-link px-2 link-white">
              รหัสรับรองมาตรฐาน
            </a>
          </li>
        }
<!--        <li class="nav-item" ngbDropdown container="body">-->
<!--          <a class="nav-link link-white dropdown-toggle" role="button" ngbDropdownToggle>-->
<!--            บริการประชาชน-->
<!--          </a>-->
<!--          <ul ngbDropdownMenu>-->
<!--            <li><a routerLink="/public/todo" ngbDropdownItem>Action</a></li>-->
<!--            <li><a routerLink="/public/todo" ngbDropdownItem>Action</a></li>-->
<!--          </ul>-->
<!--        </li>-->
        <li class="nav-item-secondary">
          <a routerLink="/pr" routerLinkActive="active" class="nav-link px-2 link-white">
            เพจประชาสัมพันธ์
          </a>
        </li>
        @if (isAuthenticated()) {
          <li class="nav-item-secondary">
            <a routerLink="/public/pr/manage" routerLinkActive="active" class="nav-link px-2 link-white">
              จัดการเพจประชาสัมพันธ์
            </a>
          </li>
        }
        <li class="nav-item-secondary">
          <a routerLink="/public/articles" routerLinkActive="active" class="nav-link px-2 link-white">
            เกี่ยวกับเครื่องหมาย Q
          </a>
        </li>
        <li class="nav-item nav-item-overflow" ngbDropdown container="body">
          <a class="nav-link link-white dropdown-toggle" role="button" ngbDropdownToggle>
            อื่นๆ
          </a>
          <ul ngbDropdownMenu>
            <li><a routerLink="/public/search/search-q" routerLinkActive="active" ngbDropdownItem>ค้นหารับรอง Q</a></li>
            <li><a routerLink="/pr" routerLinkActive="active" ngbDropdownItem>เพจประชาสัมพันธ์</a></li>
            @if (isAuthenticated()) {
              <li><a routerLink="/public/pr/manage" routerLinkActive="active" ngbDropdownItem>จัดการเพจประชาสัมพันธ์</a></li>
            }
            <li><a routerLink="/public/articles" routerLinkActive="active" ngbDropdownItem>เกี่ยวกับเครื่องหมาย Q</a></li>
          </ul>
        </li>
      </ul>

      <div class="text-end button-group">
        <app-floating-chat class="nav-chat"></app-floating-chat>
        @if (isAuthenticated()) {
          <div class="nav-item dropdown" ngbDropdown container="body" display="dynamic">
            <a class="nav-link link-white dropdown-toggle" ngbDropdownToggle>
              @let initials = getInitial(user()?.name?.split(' ')?.[0]) + getInitial(user()?.name?.split(' ')?.slice(-1)?.[0]);
              <span class="user-avatar-sm me-1">{{ initials.toUpperCase() }}</span>
              <span class="nav-user-name">{{ user()?.name }}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
              <div class="px-3 py-2">
                <div class="fw-bold">{{ user()?.name }}</div>
                <small class="text-muted">{{ user()?.email }}</small>
              </div>
              <div class="dropdown-divider"></div>
              @if (isStaff()) {
                <a class="dropdown-item" routerLink="/certificate-request/request-wait-check">
                  <i class="bi bi-briefcase me-2"></i>
                  สำหรับเจ้าหน้าที่
                </a>
                <div class="dropdown-divider"></div>
              }
              <a class="dropdown-item text-danger" (click)="logout()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                ออกจากระบบ
              </a>
            </div>
          </div>
        } @else {
          <button type="button" class="btn btn-sm btn-outline-white me-2" (click)="login()">เข้าสู่ระบบ</button>
          <a [href]="registerUrl" class="btn btn-sm btn-primary me-2">สมัครสมาชิก</a>
        }
        <button type="button" class="btn btn-sm top-nav-toggle top-nav-hamburger" (click)="menuOpen = !menuOpen" [attr.aria-expanded]="menuOpen" aria-label="Toggle navigation">
          <i class="bi" [class.bi-list]="!menuOpen" [class.bi-x-lg]="menuOpen"></i>
        </button>
      </div>
    </header>
  </div>
</div>
